import React from 'react';
import { connect } from 'react-redux';
import { hideContextMenu } from '../store/actions';
import ContextMenu from '../components/ContextMenu';

function ContextMenuRoot({show, menuItems, coordinates, $rootScope, hideContextMenu}) {
  return show ? <ContextMenu handleClose={hideContextMenu} menuItems={menuItems} coordinates={coordinates} $rootScope={$rootScope} /> : null;
}

const mapStateToProps = state => state.contextMenu;
const mapDispatchToProps = { hideContextMenu }

export default connect(mapStateToProps, mapDispatchToProps)(ContextMenuRoot);
